import {call, put, takeLatest} from "redux-saga/effects";
import {specialPrizesPresetsAPI} from "../api/api";
import {SpecialPrizesPresetsActionTypes} from "../actions/actionTypes";
import {API} from "../../../api/api";
import {ToasterService} from "../../../services/toaster/toaster.service";

function* addPreset(action) {
    try {
        const response = yield call(() =>
            specialPrizesPresetsAPI.addPreset(
                composeJson(action.payload.base)
            )
        );

        yield put({
            type: SpecialPrizesPresetsActionTypes.ADD_PRESET_SUCCESS,
            payload: response.data
        });
    } catch (e) {
        API.handleError(e.response, "Error Adding Preset");

        yield put({
            type: SpecialPrizesPresetsActionTypes.ADD_PRESET_FAIL,
            payload: e
        });
    }
}

export function* addPresetWatcher() {
    yield takeLatest(SpecialPrizesPresetsActionTypes.ADD_PRESET, addPreset);
}

function* editPreset(action) {
    try {
        const response = yield call(() =>
            specialPrizesPresetsAPI.editPreset(
                action.payload.presetId,
                composeJson(action.payload.base)
            )
        );

        ToasterService.successToast("Preset edited with success.");

        yield put({
            type: SpecialPrizesPresetsActionTypes.EDIT_PRESET_SUCCESS,
            payload: response.data
        });
    } catch (e) {
        API.handleError(e.response, "Error Editing Preset");

        yield put({
            type: SpecialPrizesPresetsActionTypes.EDIT_PRESET_FAIL,
            payload: e
        });
    }
}

export function* editPresetWatcher() {
    yield takeLatest(SpecialPrizesPresetsActionTypes.EDIT_PRESET, editPreset);
}

function* togglePresetActiveState(action) {
    const presetId = action.payload.presetId;
    const active = action.payload.active;
    try {
        let status = undefined;
        if (active) {
            status = yield call(() => specialPrizesPresetsAPI.activatePreset(presetId));
        } else {
            status = yield call(() => specialPrizesPresetsAPI.deactivatePreset(presetId));
        }

        if (status.status == 200) {
            yield put({
                type: SpecialPrizesPresetsActionTypes.TOGGLE_PRESET_ACTIVE_SUCCESS,
                payload: {
                    active: active,
                    presetId: presetId
                }
            });
        } else {
            ToasterService.errorToast("Error changing preset status.");
        }
    } catch (e) {
        API.handleError(e.response, "Error changing preset status.");

        yield put({
            type: SpecialPrizesPresetsActionTypes.TOGGLE_PRESET_ACTIVE_FAIL,
            message: e.message
        });
    }
}

export function* togglePresetActiveStateWatcher() {
    yield takeLatest(
        SpecialPrizesPresetsActionTypes.TOGGLE_PRESET_ACTIVE,
        togglePresetActiveState
    );
}

function* toggleCertifiedPreset(action) {
    const presetId = action.payload.presetId;
    const certified = action.payload.certified;
    try {
        let status = yield call(() => specialPrizesPresetsAPI.certifiedPreset(presetId, certified));

        if (status.status == 200) {
            yield put({
                type: SpecialPrizesPresetsActionTypes.TOGGLE_CERTIFIED_PRESET_SUCCESS,
                payload: {
                    certified: certified,
                    presetId: presetId
                }
            });
        } else {
            ToasterService.errorToast("Error in certifying preset.");
        }
    } catch (e) {
        API.handleError(e.response, "Error in certifying preset.");

        yield put({
            type: SpecialPrizesPresetsActionTypes.TOGGLE_CERTIFIED_PRESET_FAIL,
            message: e.message
        });
    }
}

export function* toggleCertifiedPresetWatcher() {
    yield takeLatest(
        SpecialPrizesPresetsActionTypes.TOGGLE_CERTIFIED_PRESET,
        toggleCertifiedPreset
    );
}

const composeJson = (base) => {

    const convertibleFields = [
        "contribution",
        "max_value",
        "increment_sound_value",
        "initial_value",
        "prize_gold_value",
        "prize_silver_value",
        "prize_bronze_value",
        "start_percentage",
        "min_sort",
        "max_sort"
    ];


    base.settings && Object.keys(base.settings).map((key, index) => {
        if (convertibleFields.includes(key)) {
            base.settings[key] = base.settings[key] * 100
        }
    })
    return {
        ...base,
        prizes: []
    };
};
